import { CSSObject, DefaultTheme } from "styled-components";
//App
import { useTheme } from "../../../assets/theme/ThemeProvider";

export const useTabStyles = (isActive: boolean): CSSObject => {
    const theme: DefaultTheme = useTheme();
    return {
        color: isActive ? theme.palette.accent.dark : theme.palette.black,
        fontFamily: theme.fontFamily,
        fontWeight: theme.font.weights.semiBold,
        fontSize: "1.25em",
        lineHeight: "1.5rem",
    };
};